import Cookie from '/app/utils/cookie';
import { sentry } from '/app/plugins/sentry';

const stringify = (value) => {
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    return value || 'no';
};

export const captureException = axios => {
    axios.interceptors.request.use(config => {
        config.startTime = new Date().getTime();
        return config;
    });
    axios.interceptors.response.use(null, (error) => {
        const { status } = error.response || {};

        if (![
            401, // Unauthorized
            412, // Precondition Failed
            422, // Unprocessable Entity
        ].includes(status)) {
            sentry.withScope(scope => {
                scope.setFingerprint([Cookie.get('fingerprint')]);
                scope.setTag('axios.error', error.isAxiosError ? 'yes' : 'no')
                scope.setTag('axios.status', status)

                // skip the error if it's not the last attempt
                if (error.config?.retryState && !error.config.retryState.isLastAttempt) {
                    scope.addBreadcrumb({
                        category: 'Retry',
                        message: error.config.retryState?.isLastAttempt ? 'Last attempt' : `Attempt ${error.config.retryState?.count}`,
                        data: error.config.retryState,
                    });

                    return;
                }

                if (error.config) {
                    const duration = error.config?.startTime ? new Date().getTime() - error.config.startTime : 0;

                    scope.setContext('request', {
                        url: `${error.config.baseURL}${error.config.url}`,
                        params: stringify(error.config.params),
                        method: error.config.method,
                        body: stringify(error.config.data),
                        headers: stringify(error.config.headers),
                        duration: duration ? `${duration} ms` : 'no',
                        retry: stringify(error.config.retryState),
                        timeout: duration >= error.config?.timeout ? 'yes' : 'no',
                        code: stringify(error.code),
                        message: stringify(error.message),
                    });

                }

                if (error.response) {
                    scope.setContext('response', {
                        body: stringify(error.response.data),
                        headers: stringify(error.response.headers),
                    });
                }

                sentry.captureException(error);
            });
        }

        return Promise.reject(error);
    });
};
